import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'posts-view',
  path: (params: { postSlug: string }) => `/posts/${params.postSlug}`,
}

export default ROUTE
